<template>
  <div class="bg-gob h-full flex flex-col">
    <div class="px-4 py-3 w-full flex gap-4 items-center xs:justify-center text-gray-200 text-2xl font-bold xs:relative sm:relative md:relative">
      <router-link to="/" class="flex gap-4" v-on:click.native="setShowSideBar(false)">
        <img src="../assets/img/escudo.svg" class="block w-10 h-10" v-if="!showSideBar"/>
        <img class="block h-10" src="../assets/img/logo-white-escudo.svg" v-else/>
      </router-link>
      <span class="absolute cursor-pointer right-8 top-4 text-2xl 2xl:hidden xl:hidden lg:hidden"
            @click="setShowSideBar(false)">x</span>
    </div>
    <div class="">
      <nav class="divide-y divide-white flex flex-col gap-4 mt-3">
        <ul class="flex flex-col 2xl:gap-4 xl:gap4 lg:gap-4 xs:gap-8">
          <li class="text-white font-semibold hover:bg-gobHover" v-for="(item, index) in menu" :key="index">
            <router-link :to="item.uri.includes('{query}') ? item.uri.split('{query}')[0] : item.uri" event="click"
                         class="flex gap-x-4 items-center py-2 px-4 2xl:justify-start xl:justify-start lg:justify-start xs:justify-center">
              <font-awesome-icon :icon="item.icono"></font-awesome-icon>
              <span v-if="showSideBar">{{ item.nombre }}</span></router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  name: "asidebar",
  props: {
    items: {
      type: Array
    }
  },
  methods: {
    ...mapActions({
      setShowSideBar: 'utils/setShowSideBar'
    }),
  },
  computed: {
    menu() {
      return this.items.filter(item => {
        return item.mostrar === true
      })
    },
    ...mapGetters({
      showSideBar: 'utils/getShowSideBar'
    }),
  },
}
</script>

<style scoped>

</style>
